import React from 'react';
import LogoPic from "../Assets/Images/logo.png";
const Logo = (props) => {
    return (
        <div>
            <img src={LogoPic} alt="NGKH" className="rounded mx-auto d-block mt-5" width={props.size}/>
        </div>
    );
};

export default Logo;
